/**
 * Suspends the execution of the current scope for the specified amount of time.

 * @param ms The number of milliseconds for which the execution is suspended. 
 * @returns A promise
 */
const sleep = async (ms: number) => await new Promise((r) => setTimeout(r, ms));

export default sleep;
